<template lang="html">
  <section class="sort-list-edit">
    <name-input
      :all-des="allDes"
      :is-ready="true"
      :name="de.name"
      :should-focus="!storedDataElement.name"
      :de-id="de.id"
      @on-name-input-changed="onDeNameChanged"
    ></name-input>

    <element-description
      :elem-description="de.description"
      @on-element-description-changed="onDeDescriptionChanged"
    ></element-description>

    <div class="row-container">
      <label class="query-label">
        {{ getMessageText(messages.DATA_SOURCE) }}
      </label>
      <div class="ds-select">
        <search-box-simple
          id="searchDatasource"
          :list="sourceList"
          :value="selectedSourceValue"
          @on-search-box-item-selected="onSourceSelected"
        />
      </div>
    </div>

    <div class="row-container" v-if="hasSelectedSource && hasExpressions">
      <label class="query-label fields-label">
        {{ getMessageText(messages.SORT_BY) }}
      </label>
      <div class="ds-select" ref="sortList" :style="{ height: minHeight }">
        <div
          v-for="(field, index) in sortArray"
          :key="index"
          :sortindex="index"
          draggable="draggable"
          @dragstart.stop="onDraggableStart($event)"
          @dragend.stop="onDraggableEnd($event)"
          @dragover.prevent.stop
        >
          <div
            class="dropzone"
            draggable="draggable"
            @dragenter.stop="onDraggableEnter($event)"
            @dragleave.stop="onDraggableLeave($event)"
            @drop.stop="onDraggableDrop($event)"
            @dragover.prevent.stop
            :sortindex="index"
          ></div>
          <field-row
            :id="`field-row-${field.id}`"
            :field="field"
            :all-sources="allDes"
            :selected-source="storedDataElement.selectedSource"
            :context-de="de"
            :comparables="comparables"
            data-type="comparable"
            :level="1"
            :should-focus="!field.expression"
            :app-type="appType"
            @on-field-row-change="onFieldChange"
            @on-field-row-delete="deleteField"
          />
        </div>
        <div
          class="dropzone"
          draggable="draggable"
          @dragenter.stop="onDraggableEnter($event)"
          @dragleave.stop="onDraggableLeave($event)"
          @drop.stop="onDraggableDrop($event)"
          @dragover.prevent.stop
          :sortindex="sortArray.length"
        ></div>
      </div>
    </div>

    <div class="btn-container" v-if="hasSelectedSource">
      <button class="add-btn no-user-select" @click="addField">
        {{ $t("add") }}
      </button>
    </div>
  </section>
</template>

<script lang="js">
  import { mapState, mapActions } from "vuex";
  import { v4 as uuidv4 } from "uuid";
  import { STYLE } from "@/static/global-variables";
  import { MUTATION_NAME } from "@/static/global-variables";
  import expressionBuilder from "@/views/drag-drop-pages/components/utils/expression-builder";
  import SearchBoxSimple from "@/components/SearchBoxSimple";
  import FieldRow from "@/components/queries/sort-list/FieldRow";
  import moveImg from "@/views/drag-drop-pages/img/move_img.png";
  import NameInput from "@/components/NameInput";
  import ElementDescription from "@/components/ElementDescription";

  export default  {
    name: "sort-list-edit",
    components: {
      SearchBoxSimple,
      FieldRow,
      NameInput,
      ElementDescription
    },
    props: {
      appId: {
       type: String
      },
      allDes: {
        type: Object
      },
      de: {
        type: Object
      },
      appType: {
        type: String
      }
    },
    computed: {
      ...mapState({
        messages: "messages"
      }),
      sortArray() {
        return this.storedDataElement.sort;
      },
      sourceList() {
        return this.dataSources.map(e => {
          e.label = e.name;
          return e;
        });
      },
      selectedSourceValue() {
        return this.sourceList.find(e => e.id === this.de.original);
      },
      dataSources() {
        delete this.allDes[this.de.id];
        return expressionBuilder.filterGlobalSources(this.allDes);
      },
      hasSelectedSource() {
        return Boolean(this.storedDataElement.selectedSource);
      },
      hasExpressions() {
        return Boolean(this.sortArray.length);
      }
    },
    watch: {
      selectedSourceValue: {
        handler: function() {
          this.storedDataElement.selectedSource = this.selectedSourceValue;
          if(this.de.sort) {
            for(const el of this.de.sort) {
              this.addNewExpression(el);
            }
            this.$nextTick(() => {
              this.setDataElement(this.storedDataElement);
            });
          }
        },
        deep: true,
        immediate: true
      }
    },
    mounted () {
      this.img = document.createElement("img");
      this.img.src = moveImg;
      this.elDataName = "sorlistid";
    },
    data () {
      return {
        minHeight: "",
        storedDataElement: {
          type: "DATA_EL_SORT_LIST",
          name: this.de.name,
          description: this.de.description,
          selectedSource: null,
          sort: []
        },
        comparables: {
          STRING: true,
          NUMBER: true,
          DATE: true
        }
      }
    },
    methods: {
      ...mapActions({
        setDataElement: MUTATION_NAME.SET_EDIT_DATA_ELEMENT
      }),
      onSourceSelected(val) {
        this.storedDataElement.sort = [];
        this.storedDataElement.selectedSource = val;
        this.setDataElement(this.storedDataElement);
      },
      addField() {
        this.addNewExpression();
      },
      addNewExpression(value) {
        this.storedDataElement.sort.push({
          id: uuidv4(),
          expression: value? value.expression : null,
          sortDir: value? value.sortDir.value : null
        });
      },
      onFieldChange() {
        this.setDataElement(this.storedDataElement);
      },
      deleteField(field) {
        this.$bvModal.msgBoxConfirm(this.getMessageText(this.messages.ARE_YOU_SURE), {
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.getMessageText(this.messages.OK),
          cancelTitle: this.getMessageText(this.messages.CANCEL),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            const sort = this.storedDataElement.sort.filter(e => e.id !== field.id);
            this.storedDataElement.sort = [];
            this.$nextTick(() => {
              this.storedDataElement.sort = sort;
            });
          }
        })
        .catch(err => {
          console.error(err);
        });
      },

      // draggable callbacks
      onDraggableStart(ctx) {
        const sortindex = ctx.target.attributes.sortindex.value;
        ctx.target.classList.add(STYLE.UI_ACTION.DRAG_START);
        ctx.dataTransfer.setData(this.elDataName, sortindex);
        ctx.dataTransfer.setDragImage(this.img, 10, 10);
      },
      onDraggableEnd(ctx) {
        ctx.target.classList.remove(STYLE.UI_ACTION.DRAG_START);
      },
      onDraggableEnter(ctx) {
        if(ctx.dataTransfer.types[0] === this.elDataName) {
          ctx.target.classList.add(STYLE.UI_ACTION.DROPZONE_HOVER);
        }
      },
      onDraggableLeave(ctx) {
        if(ctx.dataTransfer.types[0] === this.elDataName) {
          ctx.target.classList.remove(STYLE.UI_ACTION.DROPZONE_HOVER);
        }
      },
      onDraggableDrop(ctx) {
        if(ctx.dataTransfer.types[0] === this.elDataName && !isNaN(ctx.dataTransfer.getData(this.elDataName))) {
          this.minHeight = this.$refs.sortList.offsetHeight + "px";
          ctx.target.classList.remove(STYLE.UI_ACTION.DROPZONE_HOVER);
          ctx.dataTransfer.clearData();
          const sortindex = ctx.target.attributes.sortindex.value;
          const sort = this.storedDataElement.sort;
          const el = sort.splice(ctx.dataTransfer.getData(this.elDataName), 1);
          sort.splice(sortindex, 0, ...el);
          this.storedDataElement.sort = [];
          this.$nextTick(() => {
            this.storedDataElement.sort = sort;
            this.$nextTick(() => {
              this.minHeight = "";
            });
          });
        }
      },
      onDeNameChanged(isValidName, nameInput) {
        this.storedDataElement.name = nameInput;
        this.$emit("on-de-name-changed", isValidName);
        this.setDataElement(this.storedDataElement);
      },
      onDeDescriptionChanged(input) {
        this.storedDataElement.description = input;
        this.setDataElement(this.storedDataElement);
      }
    }
  }
</script>

<style scoped lang="scss">
  .sort-list-edit {
    min-height: 8rem;
    .row-container {
      display: flex;
      flex-direction: column;
      padding: 0 1rem;
      margin-top: 1rem;
      margin-bottom: 1rem;
      min-width: 45rem;
    }
    .query-label {
      max-width: 100px;
      padding-right: 0.5rem;
      margin-bottom: 0;
    }
    .fields-label {
      padding-top: 0.6rem;
    }
    .ds-select {
      flex: 3;
    }
    .btn-container {
      padding: 1rem 1rem 0;
      .add-btn {
        padding: 0;
        background: transparent;
        background-clip: border-box;
        border: 1px solid transparent;
        border-radius: 0.25rem;
        line-height: 1.875rem;
        color: #0070d2;
        -webkit-appearance: none;
        white-space: normal;
      }
    }
    .drag_start {
      opacity: 0.5;
      color: aqua;
    }
    .dropzone {
      min-height: 0.5rem;
      transition: min-height 0.3s ease-out;
      overflow: hidden;
    }
    .dropzone_hover {
      min-height: calc(1.875rem + 2px);
      transition: min-height 0.1s ease-in;
      background-color: peachpuff;
      opacity: 0.5;
    }
  }
</style>
